<template>
    <div class="d-flex justify-content-center mb-2">
        <template v-if="paginatedMeta.next_cursor || paginatedMeta.prev_cursor">
            <ul class="pagination pagination-rounded mb-0">
                <li class="page-item" :class="{ 'active': paginatedMeta.prev_cursor }">
                    <a
                        :class="paginatedMeta.prev_cursor ?? 'disabled'"
                        @click.prevent="setCursor(paginatedMeta.prev_cursor)"
                        class="page-link"
                        href="javascript:void(0)"
                    >Prev</a>
                </li>
                <li class="page-item" :class="{ 'active': paginatedMeta.next_cursor }">
                    <a
                        :class="paginatedMeta.next_cursor ?? 'disabled'"
                        @click.prevent="setCursor(paginatedMeta.next_cursor)"
                        class="page-link"
                        href="javascript:void(0)"
                    >Next</a>
                </li>
            </ul>
        </template>
        <template v-if="paginatedMeta.to && paginatedMeta.last_page !== 1">
            <ul class="pagination pagination-rounded mb-0">
                <template v-for="(link, index) in paginatedMeta.links" :key="index">
                    <li class="page-item" :class="{ 'active': link.active }">
                        <a
                            v-html="link.label"
                            :class="link.url ?? 'disabled'"
                            @click.prevent="setPage(link)"
                            class="page-link"
                            href="javascript:void(0)"
                        ></a>
                    </li>
                </template>
            </ul>
        </template>
    </div>
    <div class="d-flex justify-content-center" v-if="paginatedMeta.total">
        <div>
            Showing {{ props.recordName }} from {{ paginatedMeta.from }} to {{ paginatedMeta.to }} of {{ paginatedMeta.total }}
        </div>
    </div>
</template>
<script setup lang="ts">
    import { isNil } from "lodash";
    import { storeToRefs } from "pinia";
    import { usePaginationStore } from "@stores/PaginationStore";
    
    const props = withDefaults(
        defineProps<{
            recordName?: string,
            storeName?: string,
        }>(),
        {
            recordName: 'record',
            storeName: 'default',
        }
    );

    const { paginateParams, paginatedMeta } = storeToRefs(usePaginationStore(props.storeName));

    const emit = defineEmits<{
        (e:'pageChanged', value: true): void,
    }>();

    const setPage = (link) => {
        paginateParams.value.page = getPageFromUrl(link.url);
        emit('pageChanged', link);
    }

    const setCursor = (cursor) => {
        paginateParams.value.cursor = cursor;
        emit('pageChanged', cursor);
    }

    const getPageFromUrl = (url) => {
        if (url) {
            return url.split('page=')[1]
        }
    }
</script>